import React from 'react';
import { DialogTrigger } from '@adobe/react-spectrum';
import { ActionButton } from '@react-spectrum/button';
import { useOnline } from 'app/views/hooks/useOnline';
import { DisabledActionButton } from '../../core/DisabledTooltip';
import { FeedbackView } from './Form';
const feedbackEndpoint = '/api/contact';
export const Feedback = (props) => {
    const { type = 'popover', content, isQuiet = false } = props;
    const isOnline = useOnline();
    if (!isOnline) {
        return (React.createElement(DisabledActionButton, { label: typeof content === 'string' ? content : 'X', tooltip: "Feedback form is not available when working offline" }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTrigger, { "data-test-id": "header-feedback", type: type, hideArrow: true, isDismissable: true },
            React.createElement(ActionButton, { isQuiet: isQuiet }, content),
            React.createElement(FeedbackView, { endpoint: feedbackEndpoint, isVertical: type !== 'popover' })),
        props.children));
};
